export class IdentifierModel{
    id:number=0;
    name:string='';
}